import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';

import axios, { Axios } from 'axios';
import parse from "html-react-parser";
import { Link, useNavigate } from "react-router-dom";
import { variables } from './Variables.js';
import { FALSE } from 'sass';
import { Helmet } from "react-helmet"


export default function FeatureNews_Home_Ar() {




  const [isLoading, setNisLoading] = useState(false);
  const navigate = useNavigate();
  const usenavigate = useNavigate();



  const jsonUrlBoxing = variables.basename_url + 'updates/index/Athlethixnet_HomeAr_trendingnews.json';





  async function refda() {
    setNisLoading(true);
    Get_Data_FeatureNews_Home_Ar();

  }


  useEffect(() => {

    setNisLoading(true);

    refda();
  }, [])



  const [FeatureArray, setFeatureArray] = React.useState([]);

  async function Get_Data_FeatureNews_Home_Ar() {

    FeatureArray.splice(0);  //to clear All data in your page

    setNisLoading(true);

    axios.get(jsonUrlBoxing)

      .then(function (response) {
        setNisLoading(false);

        console.log(response.data);




        for (let i = 0; i <= 2 && i < response.data.length; i++) {

          FeatureArray.push({
            news_title: response.data[i].news_title,
            news_date: response.data[i].news_date,
            news_imagename: response.data[i].Image,
            link: response.data[i].link,
            Description: response.data[i].Description.replace("https://menafn.com/", variables.domain_name + "/").replace("https://menafn.com", variables.domain_name).replace("MENAFN", variables.domain).replace("MENAFN", variables.domain),
            Category: response.data[i].Category

          })
        }
      })
  }



  return (
    <>



















      <div className="feature-news-box mt-40 ">
        <div className="section-title mb-3 float-right w-100">
          <h3 className="title float-right"> الأخبار المختاره  </h3>
        </div>
        <br></br>



        <div className="   ">
          <div className='row'>
            {FeatureArray.map(da =>


              <div className='col-lg-4 col-sm-12 ' key={da.news_title}  >



                <div className='   ml-2  '>
                  <div className="feature-news-item   ">
                    <div className="feature-news-thumb">
                      <a href={da.link}>
                        <img class="card-img-top  rounded" style={{ minHeight: '217px', maxHeight: '217px' }} src={da.news_imagename} alt="Card image cap" />
                      </a>
                      <div className="meta-categores">
                        <span>{da.Category}</span>
                      </div>
                    </div>
                    <div className="feature-news-content">
                      <a href={da.link}>
                        <p className='JUUSTIFY' style={{ minHeight: '80px', maxHeight: '80px' }} >{da.news_title} </p>
                      </a>
                    </div>

                  </div>



                </div>

              </div>
            )}
          </div>



        </div>


      </div>


      <br></br>
      <br></br>
      <br></br>





    </>
  );
}



